import React, { useState, useEffect, useMemo } from "react";
import { Helmet } from "react-helmet";
import { currentDomain, currentPath } from "../Index";
import { usePromotionsData } from "../data/PromotionData";
import { useNavigate } from "react-router-dom";
import useAppPromotionTheme from "../hooks/useAppPromotionTheme";

export default function RaceToFame({ isLightMode }) {
  const isAppPromo = useAppPromotionTheme(isLightMode);
  const { promotionsData, isPromotionDataReady } = usePromotionsData();
  const data = useMemo(
    () => promotionsData.find((promo) => promo.title === "Race to Fame"),
    [promotionsData],
  );
  const [isMobile, setIsMobile] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 841);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const loggedInState = localStorage.getItem("isLoggedIn") === "true";
    setIsLoggedIn(loggedInState);
  }, []);

  // If the promo page is expired - throws error
  useEffect(() => {
    if (!isPromotionDataReady) return;

    if (!data) {
      navigate("/not-found");
    }
  }, [isPromotionDataReady, data, navigate]);

  if (!isPromotionDataReady || !data) return null;

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Fast Spin, Fast Win: Race to Fame</title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta name="description" content="ddd" />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      <div className="promotion-page-main all-page-main-container-min-height">
        <div className="promotion-page-container main-container-global-adjusted-padding">
          <div className="promotion-tnc-page">
            <div className="promotion-page-breadcrumb">
              <a
                href={
                  isAppPromo
                    ? "/promotion/".replace("/promotion", "/app-promotion")
                    : "/promotion/"
                }
              >
                Promotions
              </a>
              / <span>{data.title}</span>
            </div>
            <div className="promotion-tnc-banner">
              <img
                src={isMobile ? data.imgSrc : data.bannerSrc}
                alt={`FGH${data.title}`}
              />
              <div className="promotion-tnc-content">
                <div className="promotion-tnc-info">
                  <div
                    className={`promotion-indication-message ${data.promotionMessage.class}`}
                  >
                    {data.promotionMessage.text}
                  </div>
                  <h1>Fast Spin, Fast Win: Race to Fame</h1>
                  <h2>
                    Ready to make a name for yourself? Spin your way to the top
                    and earn your place among the FastSpin legends!
                  </h2>
                  <div className="promotion-tnc-period">
                    <strong> Event Period: </strong>
                    <span> Sept 01 (12:00PM) - Sept 29 (11:59AM), 2026 </span>
                  </div>
                </div>
                <div className="promotion-tnc-mechanic-content">
                  <strong>Promo Mechanics</strong>
                  <ol>
                    <li>Open to all FGH players.</li>
                    <li>
                      Play any FastSpin slot game available on the website -
                      fisihing games (Bounty Fishing, Fishing Treasure & Ocean
                      Carnival) are not included.
                    </li>
                    <li>
                      Accumulate a minimum weekly turnover of 5,000 to qualify
                      for the Race to Fame leaderboard.
                    </li>
                    <li>
                      Every spin brings you closer to stardom. The more turnover
                      you generate, the higher you'll climb on the leaderboard.
                    </li>
                    <li>
                      At the end of each race week, the Top 15 players with the
                      highest turnover will secure their spot among the FastSpin
                      elite and win exciting prizes.
                    </li>
                    <li>
                      <strong className="highlight">Race Schedule</strong>:
                      Every Tuesday, 12:00 PM – the following Tuesday, 11:59 AM.
                    </li>
                    <li>
                      <strong className="highlight">Finish Line</strong>: The
                      leaderboard will be finalized every Tuesday at 11:59 AM.
                    </li>
                    <li>
                      <strong className="highlight">
                        Hall of Fame Rewards
                      </strong>
                      : Prizes will be awarded every Tuesday by 3:00 PM.
                    </li>

                    <div className="table-wrapper">
                      <table
                        className="promotion-tnc-table"
                        style={{ minWidth: "0px" }}
                      >
                        <thead>
                          <tr>
                            <th>Rank</th>
                            <th>Free Spins</th>
                            <th>Bet Value</th>
                            <th>Rollover Requirement</th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr>
                            <td>1</td>
                            <td>500</td>
                            <td rowSpan="3">10.00</td>
                            <td rowSpan="5">No Rollover</td>
                          </tr>

                          <tr>
                            <td>2</td>
                            <td>400</td>
                          </tr>

                          <tr>
                            <td>3</td>
                            <td>300</td>
                          </tr>

                          <tr>
                            <td>4-10</td>
                            <td>100</td>
                            <td rowSpan="2">6.00</td>
                          </tr>

                          <tr>
                            <td>11-15</td>
                            <td>50</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <li>
                      FGH reserves the right to amend, extend, or terminate this
                      promotion at any time without prior notice.
                    </li>
                  </ol>
                  {!isAppPromo && (
                    <div className="promotion-tnc-cta">
                      <a
                        className="promotion-cta-btn"
                        href="/slots/?provider=FASTSPIN"
                      >
                        PLAY NOW
                      </a>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
